import React, { useContext } from 'react';
import { DynamicRoutingContext } from '@dnb/dynamic-routing';
import FormContainer from '../FormContainer/FormContainer';
import OddApplicationInformation from '../OddApplicationInformation/OddApplicationInformation';

function StartPage() {
  const { navigateTo } = useContext(DynamicRoutingContext);
  return (
    <FormContainer>
      <OddApplicationInformation
        onAcknowledgeInformation={() => {
          navigateTo('/odd/form');
        }}
      />
    </FormContainer>
  );
}

export default StartPage;
